import { useIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import { Header, HeaderProps } from '@rossum/components/header/Header';
import { Button } from '@rossum/ui/material';
import { SettingsBreadcrumbs } from '../../../containers/Settings/SettingsBreadcrumbs';
import { credentialCreatePath } from '../core';

type CredentialsHeaderProps = Pick<HeaderProps, 'scrollableDivRef'>;

export const CredentialsHeader = (props: CredentialsHeaderProps) => {
  const intl = useIntl();

  const title = intl.formatMessage({ id: 'features.credentials.header.title' });

  return (
    <Header
      {...props}
      breadcrumbs={<SettingsBreadcrumbs breadcrumbs={[{ label: title }]} />}
      title={title}
      description={intl.formatMessage({
        id: 'features.credentials.header.description',
      })}
      buttons={[
        <Button
          key="create"
          component={RouterLink}
          to={credentialCreatePath()}
          variant="contained"
          data-cy="create-credential-button"
        >
          {intl.formatMessage({
            id: 'features.credentials.header.buttons.create',
          })}
        </Button>,
      ]}
    />
  );
};
